<main>
    <app-header></app-header>
    <div [ngClass]="['wrapperRootPage']">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</main>